import React from 'react';
import { useConfiguration } from '../../context/configurationContext';
import loadable from '@loadable/component';
import classNames from 'classnames';
import {
  PhoneOutlined,
  MailOutlined,
  EnvironmentOutlined,
  LinkedinOutlined,
  InstagramOutlined,
  FacebookOutlined,
  YoutubeOutlined
} from '@ant-design/icons';
import { FloatButton } from 'antd';
import logoinverse from '../../assets/logo-inverse.jpg';

import css from './FooterContainer.module.css';
import { useIntl } from 'react-intl';
import { ExternalLink, NamedLink } from '../../components';

const SectionBuilder = loadable(
  () => import(/* webpackChunkName: "SectionBuilder" */ '../PageBuilder/PageBuilder'),
  {
    resolveComponent: components => components.SectionBuilder,
  }
);

const FooterComponent = () => {
  const { footer = {}, topbar } = useConfiguration();

  // If footer asset is not set, let's not render Footer at all.
  if (Object.keys(footer).length === 0) {
    return null;
  }

  // The footer asset does not specify sectionId or sectionType. However, the SectionBuilder
  // expects sectionId and sectionType in order to identify the section. We add those
  // attributes here before passing the asset to SectionBuilder.
  const footerSection = {
    ...footer,
    sectionId: 'footer',
    sectionType: 'footer',
    linkLogoToExternalSite: topbar?.logoLink,
  };

  const intl = useIntl();

  return (
    <div className={css.footer}>
      <div className={css.footerTop}>
        <div className={css.rightBlock}>
          <div className={classNames(css.linksBlock, css.linksFirst)}>
            <div className={css.logo}>
              <img src={logoinverse} alt='Logo' height={50} />
            </div>
            <div className={css.company}>
              <div><PhoneOutlined /> 214-427-1022</div>
              <div><a href={`mailto:info@iparley.com`} className={css.link}><MailOutlined /> &nbsp; info@iparley.com </a></div>
              <div><EnvironmentOutlined />4421 Tradition Trl, Plano, TX 75093</div>
            </div>
          </div>
          <div className={css.linksBlock}>
            <h2>{intl.formatMessage({ id: 'FooterContainer.companyHeading' })}</h2>
            <a href={'/about'} className={css.link}>
              {intl.formatMessage({ id: 'FooterContainer.aboutLink' })}
            </a>
            <NamedLink className={css.link} name="BlogPage">
              {intl.formatMessage({ id: 'FooterContainer.blogLink' })}
            </NamedLink>
            <NamedLink className={css.link} name="FAQCustomPage">
              {intl.formatMessage({ id: 'FooterContainer.faqLink' })}
            </NamedLink>
            <NamedLink className={css.link} name="SupportPage">
              Support
            </NamedLink>
            {/* <NamedLink className={css.link} name="BlogPage">
              {intl.formatMessage({ id: 'FooterContainer.blogLink' })}
            </NamedLink>
            <NamedLink className={css.link} name="ContactPage">
              {intl.formatMessage({ id: 'FooterContainer.contactLink' })}
            </NamedLink> */}
          </div>
          <div className={css.linksBlock}>
            <h2>{intl.formatMessage({ id: 'FooterContainer.productHeading' })}</h2>
            <NamedLink className={css.link} name="LandingPage">
              {intl.formatMessage({ id: 'FooterContainer.overviewLink' })}
            </NamedLink>
            {/* <NamedLink className={css.link} name="LandingPage">
              {intl.formatMessage({ id: 'FooterContainer.featuresLink' })}
            </NamedLink>
            <NamedLink className={css.link} name="LandingPage">
              {intl.formatMessage({ id: 'FooterContainer.solutionsLink' })}
            </NamedLink> */}
            <NamedLink className={css.link} name="PricingsPage">
              {intl.formatMessage({ id: 'FooterContainer.pricingLink' })}
            </NamedLink>
          </div>
          <div className={css.linksBlock}>
            <h2>{intl.formatMessage({ id: 'FooterContainer.otherHeading' })}</h2>
            <NamedLink className={css.link} name="PrivacyPolicyCustomPage">
              {intl.formatMessage({ id: 'FooterContainer.privacyPolicyLink' })}
            </NamedLink>
            <NamedLink className={css.link} name="TermsAndConditionsCustomPage">
              {intl.formatMessage({ id: 'FooterContainer.termsLink' })}
            </NamedLink>
          </div>
        </div>
      </div>
      <div className={css.footerBottom}>
        <div className={css.footerBottomLeft}>
          Follow Us
          <div className={css.footerSocial}>
            <a href={'https://www.linkedin.com/showcase/iparley'} target='_blank' style={{ color: 'white' }} >
              <LinkedinOutlined />
            </a>
            {/* <InstagramOutlined />
            <FacebookOutlined /> */}
            <a href={'https://www.youtube.com/@iParley'} target='_blank' style={{ color: 'white' }} >
              <YoutubeOutlined />
            </a>
          </div>
        </div>
        <div className={css.footerBottomRight}>
          <p>
            {/* © 2025 {intl.formatMessage({ id: 'FooterContainer.companyName' })}.{' '}
            {intl.formatMessage({ id: 'FooterContainer.allRightsReserved' })} */}
            © {new Date().getFullYear()} iParley. {' '}
            {intl.formatMessage({ id: 'FooterContainer.allRightsReserved' })}
          </p>
        </div>
      </div>
      <FloatButton.BackTop />
    </div>
  );
};

// NOTE: if you want to add dynamic data to FooterComponent,
//       you could just connect this FooterContainer to Redux Store
//
// const mapStateToProps = state => {
//   const { currentUser } = state.user;
//   return { currentUser };
// };
// const FooterContainer = compose(connect(mapStateToProps))(FooterComponent);
// export default FooterContainer;

export default FooterComponent;
